<template>
    <ul class="footer__menu">
      <li class="footer__menu-item">
        <a :href="$getSubdomainLink('portal', '/contact-us')" class="btn btn-default">
          Contact Us
        </a>
      </li>
      <li class="footer__menu-item">
        <a :href="$getSubdomainLink('portal', '/terms')" class="btn btn-default">
          Terms & Conditions
        </a>
      </li>
      <li class="footer__menu-item">
        <a :href="$getSubdomainLink('portal', '/privacy')" class="btn btn-default">
          Privacy Policy
        </a>
      </li>
      <li class="footer__menu-item">
          <a :href="$getSubdomainLink('portal', '/cancellation')" class="btn btn-default">
            Cancellation & Refund
          </a>
      </li>
    </ul>
</template>
<script>
export default {

}
</script>

<style
  lang="scss"
  scoped
>
.footer__menu {
  &-item:not(:last-of-type) {
    margin-bottom: 8px;
  }
}
</style>
